import React from 'react'
import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'

const FontFormat = props => {
  const { onChange, currentStyle } = props

  return (
    <div 
      className={styles['wrapper-text-format']}
    >
      <span 
        onClick={() => onChange( 'BOLD' )}
        aria-hidden={true}
      >
        <IconComponent
          icon="text-bold"
          fill={currentStyle.has( 'BOLD' ) && '#0F7BFF'}
        />
      </span>
      <span 
        onClick={() => onChange( 'ITALIC' )}
        aria-hidden={true}
      >
        <IconComponent
          icon="text-italic"
          fill={currentStyle.has( 'ITALIC' ) && '#0F7BFF'} 
        />
      </span>
      <span 
        onClick={() => onChange( 'UNDERLINE' )}
        aria-hidden={true}
      >
        <IconComponent
          icon="text-underline"
          fill={currentStyle.has( 'UNDERLINE' ) && '#6FB0FF'}
          fill2={currentStyle.has( 'UNDERLINE' ) && '#0F7BFF'}
        />
      </span>

    </div>
  )
}

export default FontFormat


// WEBPACK FOOTER //
// ./src/components/editors/FontFormat/index.js